import { parseBooleanFromString } from '@/legacy/utils/boolean';

export const isTestLoginEnabled = (): boolean =>
  parseBooleanFromString(import.meta.env.VITE_TEST_LOGIN_ENABLED);

export const testLoginConfig = {
  secret:
    import.meta.env.VITE_TEST_LOGIN_SECRET ??
    'some-secret-key-for-development-that-does-not-matter',
  issuer: 'dev-local-issuer',
  audience: 'tlp',
};
